import { useEffect, useRef } from 'react';
import type { ResultData } from '@/domain';
import { trackFhhSearchError } from '@/lib/tracking/tracking';

export const useResultsTracking = (loading: boolean, error: unknown, data: ResultData | undefined) => {
    const hasTrackedErrorRef = useRef(false);
    const hasTrackedEmptyRef = useRef(false);

    useEffect(() => {
        if (loading) return;

        const results = data?.resultItems ?? null;

        if ((error || !results) && !hasTrackedErrorRef.current) {
            trackFhhSearchError('fetch_failed');
            hasTrackedErrorRef.current = true;
        } else if (results && results.length === 0 && !hasTrackedEmptyRef.current) {
            trackFhhSearchError('empty_results');
            hasTrackedEmptyRef.current = true;
        }
    }, [loading, error, data]);

    useEffect(() => {
        hasTrackedErrorRef.current = false;
        hasTrackedEmptyRef.current = false;
    }, [data]);
};
